import { Col, Row, Spin } from '@qonsoll/react-design'

import { CONTENT_TYPES } from '__constants__'
import { Empty } from 'antd'
import { Fragment } from 'react'
import PropTypes from 'prop-types'
import parser from 'html-react-parser'
import { useGetContent } from 'domains/Content/hooks'
import { useTranslations } from '@qonsoll/translation'

const Content = (props) => {
  const { contentType } = props

  const [contentData, loading] = useGetContent(contentType)
  const { t } = useTranslations()

  return (
    <Row noGutters h="center">
      <Col>
        {loading ? (
          <Spin />
        ) : contentData ? (
          <Fragment>{parser(contentData?.content)}</Fragment>
        ) : (
          <Empty description={t('No data')} />
        )}
      </Col>
    </Row>
  )
}

Content.propTypes = {
  contentType: PropTypes.oneOf(Object.values(CONTENT_TYPES))
}

export default Content
